export default __webpack_public_path__ + "static/media/Inter-UI-ExtraBold.c8f757ee.woff";